const asNumber = value => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * Apply the institutional competency rules to a unit result.
 * FA and SA are displayed/checked as whole marks, while attendance keeps its
 * recorded percentage for the >70 threshold.
 */
export const getSummativeCompetency = mark => {
  const formative = Math.round(asNumber(mark?.formative_total_60));
  const summative = Math.round(asNumber(mark?.converted_marks));
  const total = formative + summative;
  const attendance = asNumber(mark?.attendance_percentage);

  let remark = 'NYC';
  if (attendance <= 70) {
    remark = 'NYC-AT';
  } else if (formative > 29 && summative > 19) {
    if (total > 79) remark = 'A. Mastery';
    else if (total > 65) remark = 'Proficient';
    else if (total > 49) remark = 'Competent';
  } else if (formative < 30 && summative < 20) {
    remark = 'NYC';
  } else if (formative < 30) {
    remark = 'NYC-F';
  } else if (summative < 20) {
    remark = 'NYC-S';
  }

  return { formative, summative, total, attendance, remark };
};

export const formatAttendance = value => {
  const attendance = asNumber(value);
  return Number.isInteger(attendance) ? String(attendance) : attendance.toFixed(1);
};

export const summativeCompetencyKey = 'Key: A. Mastery – Attained mastery · NYC – Not Yet Competent · NYC-F – Not Yet Competent in Formative · NYC-S – Not Yet Competent – Summative · NYC-AT – Not Yet Competent – Attendance.';
